import { generatePath, matchPath } from 'react-router';

import { call, put, select, takeLatest } from 'redux-saga/effects';

import { NEW_ENTITY_ID } from 'constants/EntityTitles';
import { PATH } from 'constants/RoutesConstants';
import { putAndWait } from 'modules/app/sagas';
import { scopeToPage } from 'modules/app/sagas/utils';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { navigate } from 'modules/router/navigate';
import * as types from 'modules/screensaver/actionTypes';
import { getCurrentLocation } from 'selectors/router';

import { fetchScreensaver } from '../actions/core';
import { screensaverDetailsIsReady } from '../actions/details';
import { SCREENSAVER_DETAILS } from '../constants';

/** @param {import("../types/actions").CreateScreensaverSuccessAction} action */
function* afterCreateWorker({ payload: screensaver }) {
  const { id: screensaverId, dealerId } = screensaver;
  const { path } = dealerId ? PATH.DEALER_CONFIG_SCREENSAVER_DETAILS : PATH.GROUP_CONFIG_SCREENSAVER_DETAILS;
  yield call(navigate, generatePath(path, { screensaverId }), { replace: true });
}

const DETAILS_PATH = [PATH.GROUP_CONFIG_SCREENSAVER_DETAILS, PATH.DEALER_CONFIG_SCREENSAVER_DETAILS];

function* initializeDetailsPage() {
  const location = yield select(getCurrentLocation);
  const { params } = DETAILS_PATH.reduce((acc, { path }) => acc || matchPath(path, location), undefined);
  const { screensaverId } = params;

  if (screensaverId !== NEW_ENTITY_ID) {
    yield putAndWait(fetchScreensaver(screensaverId, { target: SCREENSAVER_DETAILS }));
  }
  yield put(screensaverDetailsIsReady());
}

function* onPageWorker() {
  yield call(initializeDetailsPage);
  yield takeLatest(types.CREATE_SCREENSAVER_SUCCESS, afterCreateWorker);
}

const channelPattern = ({ type, payload }) => type === LOCATION_CHANGE && payload.action !== 'REPLACE';

export default function* screensaverDashboardSaga() {
  yield scopeToPage(DETAILS_PATH, onPageWorker, undefined, channelPattern);
}
